import React, { useState, useEffect } from 'react';
import {
  Grid,
  Column,
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  Button,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Pagination,
  Select,
  SelectItem,
  Theme,
} from '@carbon/react';
import { getCountriesList, getAccountingInformationForView } from '../../services/services';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";

const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'commcode',
    header: 'Code',
  },
  {
    key: 'name',
    header: 'Name',
  },
  {
    key: 'minor',
    header: 'Minor',
  }
];

const ViewCommodities = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [countryList, setCountryList] = useState([]);
  const [countryChosen, setCountryChosen] = useState();
  const [rows, setRows] = useState([]);

  const getCountries = async () => await getCountriesList()
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            response.sort((a, b) => a.countryName.localeCompare(b.countryName));
            setCountryList(response);
          })
      }    
    });
  
  const goHomeScreen = () => {
    navigate('/home')
  };

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }

  const getCommodities = async (request) => await getAccountingInformationForView(request)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            parseResponse(response);
          })
      }    
    }); 

  const parseResponse = (response) => {
    if (response.length > 0) {
      const resParsed = response.map((res, i) => {
        const parsed = {};
        parsed["id"] = i.toString();
        parsed["ctrycode"] = res.key.ctrycode;
        parsed["compcode"] = res.key.compcode;
        parsed["commcode"] = res.key.commcode;
        parsed["name"] = res.description;
        parsed["minor"] = res.minor;
        return parsed;
      });
      setRows(resParsed);

    }
  };

  const handleTypeSelect = (e, row) => {
    const type = e.target.id;
    if (type.includes("country")) {
      setCountryChosen(e.target.value);
    }
    let request = {};
    request.ctrycode = e.target.value;
    request.action = 'commodities';
    getCommodities(request);
  };

  useEffect(() => {
    getCountries();
  }, []);

  return (
    <>
      <h2 className="table-title">Commodities List</h2>
      <Grid>
        <Theme theme="g90">
          <CommodityHeader />
        </Theme>
        <Column lg={16} >
        <Button className='style-bttbackID' size="lg" style={{marginBottom: '20px'}} onClick={goHomeScreen}>Back to Home</Button>          
          <DataTable
            isSortable={true}
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              onInputChange
            }) => (

              <TableContainer>
                <Select className="style-select"
                  labelText=""
                  defaultValue={countryChosen}
                  value={countryChosen}
                  id="countryDept"
                  onChange={(e) => handleTypeSelect(e)}
                >
                  <SelectItem
                    label="Select country"
                  />
                  {countryList.map((country) => (
                    <SelectItem key={country.countryName} value={country.countryCode} text={country.countryName} />
                  ))}

                </Select>
                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                    {/* pass in `onInputChange` change here to make filtering work */}
                  </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>

                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, i) => (
                      <TableRow {...getRowProps({ row })}>
                        {row.cells.map(cell => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}

                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />
        </Column>
      </Grid>

    </>
  );
};

export default ViewCommodities;